import { render, staticRenderFns } from "./screenAdvancedVideoSelector.vue?vue&type=template&id=266da846&scoped=true"
import script from "./screenAdvancedVideoSelector.vue?vue&type=script&lang=js"
export * from "./screenAdvancedVideoSelector.vue?vue&type=script&lang=js"
import style0 from "./screenAdvancedVideoSelector.vue?vue&type=style&index=0&id=266da846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266da846",
  null
  
)

export default component.exports